import { Link } from "react-router-dom";
import {
  TeamMemberImg1,
  TeamMemberImg2,
  TeamsLinkedIn,
} from "../../constant/ImagesS3";
import "./AboutUs.css";
function Teams() {
  return (
    <div className="teams-container">
      <div className="teams-text-box">
        <div className="teams-sub-head">Our Team</div>
        <div className="teams-desc-text">
          At Bataiyo, people are our greatest strength. By digitizing
          word-of-mouth and building a zero-commission, trust-driven ecosystem,
          we aim to spark meaningful change and play our part in{" "}
          <span className="teams-desc-blue-text"> nation-building.</span>{" "}
        </div>
      </div>
      <div className="teams-img-box">
        <img
          src={TeamMemberImg1}
          alt="team-member"
          className="team-member-img"
        />
        <div className="teams-member-info">
          <div className="teams-member-name">Jitender Bhutani</div>
          <div className="teams-member-role">CEO</div>{" "}
          <Link
            to="https://www.linkedin.com/in/jitender-bhutani"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={TeamsLinkedIn}
              alt="linkedIn"
              className="teams-linkedIn-icon"
            />
          </Link>
        </div>
      </div>
      <div className="teams-img-box">
        <img
          src={TeamMemberImg2}
          alt="team-member"
          className="team-member-img"
        />
        <div className="teams-member-info">
          <div className="teams-member-name">Dhanik Kaul</div>
          <div className="teams-member-role">COO</div>{" "}
          <Link
            to="https://www.linkedin.com/in/dhanik-koul-153409209"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={TeamsLinkedIn}
              alt="linkedIn"
              className="teams-linkedIn-icon"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Teams;
